import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getCategories = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/article-categories")
}
const getArticles = (clinicId,pageNo=0,pageSize=2,sortBy="lastmodified",sortOrder="asc",categoryId=0)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/articles?pageNo="+pageNo+"&pageSize="+pageSize+"&sortBy="+sortBy+"&order="+sortOrder+"&categoryId="+categoryId)
}
const getArticleById = (clinicId,id)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/articles/"+id)
}
const searchPatientByEmail = (clinicId,searchEmail)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/search?email="+searchEmail)
}
const searchArticle  = (clinicId,searchText) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/articles?title="+searchText)
}
const sendArticleToPatient = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/articles/send-to-patients", data)
}

const articlesService = {
   getCategories,
   getArticles,
   getArticleById,
   searchPatientByEmail,
   searchArticle,
   sendArticleToPatient
}

export default articlesService